import { createSelector } from 'reselect';

export const getTools = (state) => {
  return state.tools;
}

export const getSelectedTool = createSelector(
  [getTools],
  (tools) => {
    return Object.keys(tools).reduce( (selected, tool) => {
      if (tools[tool] === true) {
        selected = {tool, field : tools.field, value : 'red'};
      }
      return selected;
    }, undefined);
  }
)



// WEBPACK FOOTER //
// ./src/selectors/tools.js